const KEY = ['COLLECTION'];

export { KEY };
